import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WMVbookingDetails.html?raw';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import { WebcalendarTypes } from "../../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";


interface WMVitemDetails {
    serviceBookingTables: Array<{
        serviceBooking: Array<StaticTable.Layout>
    }>;
    isHTMLdetailtext: boolean;
    content: string;
}
class WMVbookingDetails extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private itemData: WMVitemDetails;
    
    calendarConfig: WebcalendarTypes.WebcalendarItemRequestData = null;

    assignedEntities: any = null;

    standbyTarget: any = null;

    private _isInitialDataSet: boolean = false;

    genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

    wmvBookingContent: HTMLElement;
    serviceBookingListContainer: HTMLElement;
    loadingBar: HTMLElement;

    //WMWmainWrapper: WMV_Main;

    private _loadItemDetails(): void {


        let requestUrl = window.appRoot + "Calendar/GetItemDetails";
        this.StandbyStart();

        let data = this.calendarConfig;

        let requestParams = {
            'jsonData': JSON.stringify(data)
        };

        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._onLoadDetailsResult),
            lang.hitch(this, this._onLoadDetailsError),
            false // sync
        );
    }

    private _onLoadDetailsResult(itemData: WMVitemDetails): void {

        console.log("Details loaded!", itemData);
        this._applyItemData(itemData);

        this.StandbyStop();

    }

    private _applyItemData(itemData: WMVitemDetails): void{

        this.itemData = itemData;

        this.setItemDetailText(this.itemData.content, this.itemData.isHTMLdetailtext)

        this.buildServiceBookingList();

    }

    setItemDetailText(content: any, isHTML: boolean) {
        let text = content;
        if (content) {
            this._isInitialDataSet = true;
        }
        // prüfen ob der Text ein Objekt ist mit HTML-Content!
        if (isHTML) { 
            let div = this.UiModder.domConstruct.create("div", { "className": "itemDetailHTML" });
            this.UiModder.domAttr.set(div, "innerHTML", content);
            text = div.outerHTML;
        }
            

        if (!isHTML) {
            let pre = this.UiModder.domConstruct.create("pre", { "className": "itemDetailText" });
            this.UiModder.domAttr.set(pre, "innerHTML", content);
            text = pre.outerHTML;
        }

        this.UiModder.domAttr.set(this.wmvBookingContent, "innerHTML", text);
    }

    private buildServiceBookingList() {
        this.UiModder.domConstruct.empty(this.serviceBookingListContainer);

        if (this.itemData.serviceBookingTables) {
            
        }
    }

    _onLoadDetailsError(error: more.requestErrorMessage): void{

        //this.WMWmainWrapper.publishToastMessage("Error loading event details", toasterIcons.error, 0, error.Message);
        alert("Error loading event details:\r\n" + error.Message);

        this.StandbyStop();
    }


    reload(): void {

        this._loadItemDetails();
    }


    //StandbyStart(target?: HTMLElement, loadingBar?: boolean) {
    //    if (loadingBar === true) {
    //        this.UiModder.domClass.add(this.loadingBar, "ego_animated_progressBar");
    //        return;
    //    } else {
    //        let self: any = this;
    //        self.inherited(arguments);
    //    }
    //}

    //StandbyStop(loadingBar?: boolean) {
    //    if (loadingBar === true) {
    //        this.UiModder.domClass.remove(this.loadingBar, "ego_animated_progressBar");
    //        return;
    //    } else {
    //        let self: any = this;
    //        self.inherited(arguments);
    //    }
    //}

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this._standbyOverlay.target = this.standbyTarget; //??

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.reload();

    }    
}

export default mdsWidget(WMVbookingDetails);